<!-- Share projects pane -->

<div class="fdm-share-window fdm-floatbar">

  <div class="fdm-sidebar-header fdm-sidebar-header-primary fdm-buttons fdm-shadow clearfix">

    <li class="fdm-linked fdm-options-button pointer" (click)="cancel()">
      <fa-icon icon="times"></fa-icon>
    </li>

    <h2>{{ 'SETTINGS.SHARE_PROJECT' | translate }}</h2>
  </div>
  <div class="fdm-sidebar-body  fdm-sidebar-content fdm-text-medium">

  <span class="fdm-layer-section-title">{{ 'SETTINGS.PROJECT_MEMBERS' | translate }}
    <button class="fdm-share-window-button float-right" style="padding:0!important"
         mat-mini-fab color="primary"  (click)="navigateToRoute(routes.MAIN + '/' +  routes.ADMIN_USERS)"
         [matTooltip]="'NAV.MANAGE_USERS' | translate">
      <fa-icon icon="users"></fa-icon>
    </button>
  </span>
    <!-- <h6 style="color: #666;" class="pt-2" translate>SHARES.SHARED_WITH_USERS</h6> -->

  <ng-template [ngIf]="users.length > 0" [ngIfElse]="usersLoading">
    <div class="p-2 mb-2">
      <div class="ml-2" *ngFor="let user of users">
        {{user.name}} <span *ngIf="service.myProfile.id == user.id" class="badge badge-primary">{{ 'GENERIC.YOU' | translate }}</span>
      </div>
    </div>
  </ng-template>
  <ng-template class="p-2 mb-2" #usersLoading>
    <div class="ml-2">
      <em>Loading</em>
    </div>
  </ng-template>

  <!-- Shaz quick n dirty, feel free to replace. Note this sort of supersedes the list directly above ^ -->
  <!-- commented out until we're happy with where it goes
  <div style="padding:5px; border:1px dashed red;">
    <b>TODO Alex make pretty (shaz quick n dirty version)</b>
    <div *ngFor="let role of roleGroups">
      <b>{{ role.name }}</b>
      <ul>
        <li *ngFor="let user of role.users">{{ user.name }} <fa-icon icon="times" (click)="removeUserFrom(role.uid,user)"></fa-icon></li>
      </ul>
      <div qmap-question [qMap]="{type:'object',obj_type:'User',title:'Add user',id:'user'}" (qmap-change)="addUserTo(role.uid,$event)"></div>


    </div>

  </div>
-->

    <mat-divider class="m-2"></mat-divider>

    <span class="fdm-layer-section-title"><!--{{ 'SETTINGS.EXTERNAL_USERS' | translate }}-->
      {{ 'SETTINGS.SHARES' | translate }}
      <button id="share-link" class="fdm-share-window-button float-right" style="padding:0!important"
          mat-mini-fab color="primary" (click)="invite()"
          [matTooltip]="'SHARES.ADD' | translate">
        <fa-icon icon="user-plus"></fa-icon>
      </button>
    </span>
    <div *ngIf="mapService?.shareClients | sceneFilter:mapService?.scene as filteredShareClients">
      <div *ngIf="!filteredShareClients?.length">
        {{ 'GENERIC.NONE' | translate }}
      </div>
      <div *ngIf="filteredShareClients?.length">
        <div class="pb-1 fdm-sidebar-scene-layer" *ngFor="let cur of filteredShareClients">
          <span class="fdm-layer-title-disabled">
            <fa-icon icon="link"></fa-icon>
            {{ cur.name }}, {{ 'GENERIC.CREATED' | translate }} {{ cur.dateMade | dateAgo | async }}
          </span>
          <fa-icon icon="trash" class="float-right ml-2 text-danger" (click)="rm(cur)" id="disable-share" matTooltip=" {{ 'SHARES.DISABLE_ACCESS' | translate }}"></fa-icon>
          <fa-icon icon="code" class="fdm-linked ml-2 float-right" (click)="embed(cur)" id="embed" matTooltip=" {{ 'SHARES.EMBED_CODE' | translate }}"></fa-icon>
          <fa-icon icon="copy" class="fdm-linked float-right" (click)="cp(cur)" id="copy-clipboard" matTooltip=" {{ 'GENERIC.COPY_CLIPBOARD' | translate }}"></fa-icon>
          <!-- <textarea style="height:100px;font-size:9px;width:100%;">{{ cur | json }}</textarea> -->
        </div>
      </div>
    </div>

    <div class="alert alert-danger mt-3" *ngIf="maxSharesReached">
      {{ 'SHARES.MAX_SHARES_REACHED' | translate }}
    </div>
  </div>

  <!--
  <div class="p-2">
    <button class="float-left mr-2 pointer mr-1"
      mat-mini-fab color="primary" (click)="invite()"
      [matTooltip]="'SHARES.ADD' | translate" ><mat-icon>add</mat-icon>
      </button>
    <h6 style="color: #666;" class="pt-2" translate>SHARES.TITLE</h6>
  </div>
  <mat-divider class="m-2"></mat-divider>

  <div class="p-2" *ngIf="mapService?.shareClients?.length">
    <div class="pb-1" *ngFor="let cur of mapService.shareClients"><fa-icon icon="user"></fa-icon> {{ cur.name }} <fa-icon icon="times" (click)="rm(cur)" class="float-right text-danger"></fa-icon></div>
  </div>
  <mat-divider class="m-2"></mat-divider>
  <div class="p-2">
    <button class="float-left mr-2 pointer mr-1"
            mat-mini-fab color="primary"  (click)="navigateToRoute(routes.MAIN + '/' +  routes.ADMIN_USERS)"
            [matTooltip]="'NAV.MANAGE_USERS' | translate" ><mat-icon>group</mat-icon>
    </button>
    <h6 style="color: #666;" class="pt-2" translate>SHARES.SHARED_WITH_USERS</h6>
  </div>

  <div class="p-2 mb-2" *ngIf="users.length > 0">
        <div class="ml-2" *ngFor="let user of users">
          {{user.name}} <span *ngIf="service.myProfile.id == user.id" class="badge badge-info">{{ 'GENERIC.YOU' | translate }}</span>
        </div>
  </div>
  -->
</div>
